import React from "react";
import { BCMSDate, BCMSDefaultModel, DisabledPrompt, useBCMSContext, BCMSStateManagerCRUD, useStateManager, BCMSRecord, StateManager, useRoute, useWorkflow } from "bcms-react";
import Classes, { TransferTemplate } from "model";
import { CenterContentContainer, ContentHeaderView, PageContainer, PageContentView } from "components/shared";
import { SecondaryButton } from "components/ui";
import TransferTemplatesTable from "./components/TransferTemplatesTable";
import MobileTransferTemplatesTable from "./components/MobileTransferTemplatesTable";
import { CheckmarkBanner } from "components/shared/views/ConfirmBannerView";

import "./styles.css";
import "./mobile.css";

/**
 * @function TransferTemplatesPage
 * @param {STRING} templateName - Sets the transfer template name text for the CheckmarkBanner.
 * @return {React.Component}
 * @exported true
 * @description The main component for TransferTemplatesPage
 */
export default function TransferTemplatesPage(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const data = { ...getDefaultData(), ...props.data ?? {} };
    const ui = { ...getDefaultUI(), ...props.ui ?? {} };
    const { nextStep } = useWorkflow() ?? {};

    const controller = (state, setState) => ({
        data: state.data,
        ui: state.ui,
        
        onAddNewTemplateClick: () => nextStep({ data })
    });

    return (
        <PageContainer className="transfer-templates-page" state={ { data, ui } } controller={ controller }>
            <PageContent/>
        </PageContainer>
    )
}

export const getDefaultData = (templates, addedTemplate, templateAdded) => ({
    templates: templates ? templates : TransferTemplate.initAll().sort((a, b) => {
        // Sort the templates alphabetically ascending, so "a - z".
        const aName = a.name.toLowerCase();
        const bName = b.name.toLowerCase();
        if (aName < bName) return -1;
        if (aName > bName) return 1;
        return 0;
    }),
    addedTemplate,
    templateAdded: templateAdded ?? false
});

export const getDefaultUI = () => {
    const accordions = TransferTemplate.initAll().reduce((acc, item) => {
        acc[`Accordion_${ item.id }`] = { isActive: false };
        return acc;
    }, {});
    
    return {
        // Use these props in capture components to show active rows.
        // "Accordion_0": { isActive: true },
        // "Accordion_1": { isActive: true }
        ...accordions
    }
};

function PageContent(props) {
    const { data, onAddNewTemplateClick } = useStateManager();
    const templates = data.templates;
    const addedTemplate = data.addedTemplate ?? {};
    const templateAdded = data.templateAdded;

    return (
        <PageContentView>
            <CenterContentContainer>
                { templateAdded && <CheckmarkBanner text={`Transfer Template "${ addedTemplate.name }" is added successfully.`} /> }
                <ContentHeaderView text="Transfer Template" />
                <SecondaryButton dataPoint="Add_NewTemplate_Button" text="Add New Template" className="add-new-template-button" onClick={ onAddNewTemplateClick } />

                <div className="show-on-desktop">
                    <TransferTemplatesTable templates={ templates } />
                </div>
                <MobileTransferTemplatesTable templates={ templates } />

            </CenterContentContainer>
        </PageContentView>
    );
}